import Vue from 'vue'
import { Tooltip,Button, Container, Header, Main, MessageBox, Row, Col, Breadcrumb, BreadcrumbItem, Carousel, CarouselItem, Dialog, Pagination } from 'element-ui'

Vue.use(Button);
Vue.use(Container);
Vue.use(Header);
Vue.use(Main);
Vue.use(Row);
Vue.use(Col);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Dialog);
Vue.use(Pagination);
Vue.use(Tooltip)

Vue.prototype.$msgbox = MessageBox;
